import { all, fork } from "typed-redux-saga";
import { addEditConfigurationDialogSaga } from "./components/add-edit-configuration-dialog/add-edit-configuration-dialog-saga";
import { configuratorSaga } from "./configurator-saga";
import { viewSettingsSaga } from "./components/view-settings/view-settings-saga";

export function* combinedConfiguratorSaga() {
  yield all([fork(addEditConfigurationDialogSaga), fork(configuratorSaga), fork(viewSettingsSaga)]);
}
